export default "__VITE_ASSET__gn9lgMph__"